import React from 'react';
import Footer from './components/Footer';
import GifsSection from './components/GifsSection';
import Navbar from './components/Navbar';

function App() {
  return (
    <div>
     <Navbar />
     <GifsSection />
     <Footer />
    </div>
  );
}

export default App;
